import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterSourceTypeList as getWaterSourceTypeListApi,
	getWaterSourceTypeListQuery as getWaterSourceTypeListQueryApi,
	getWaterSourceType as getWaterSourceTypeApi,
	addNewWaterSourceTypeApi,
	updateWaterSourceTypeApi,
	deleteWaterSourceTypeApi,
	checkWaterSourceTypeExistsApi,
} from '../../helpers/water_source_type/api_helper';

export const getWaterSourceTypeList = createAsyncThunk(
	'waterSourceType/getWaterSourceTypeList',
	async () => {
		try {
			const response = await getWaterSourceTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterSourceTypeListQuery = createAsyncThunk(
	'waterSourceType/getWaterSourceTypeListQuery',
	async params => {
		try {
			const response = getWaterSourceTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterSourceType = createAsyncThunk(
	'waterSourceType/getWaterSourceType',
	async water_source_type_id => {
		try {
			const response = await getWaterSourceTypeApi(water_source_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterSourceType = createAsyncThunk(
	'waterSourceType/addNewWaterSourceType',
	async water_source_type => {
		try {
			const response = await addNewWaterSourceTypeApi(water_source_type);
			toast.success('Tipo de Fuente de Agua agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterSourceType = createAsyncThunk(
	'waterSourceType/updateWaterSourceType',
	async water_source_type => {
		try {
			const response = await updateWaterSourceTypeApi(water_source_type);
			toast.success('Tipo de Fuente de Agua actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterSourceType = createAsyncThunk(
	'waterSourceType/deleteWaterSourceType',
	async water_source_type => {
		try {
			const response = await deleteWaterSourceTypeApi(water_source_type._id);
			toast.success('Tipo de Fuente de Agua eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_source_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterSourceTypeExists = createAsyncThunk(
	'waterSourceType/checkWaterSourceTypeExists',
	async name => {
		try {
			const response = await checkWaterSourceTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
